import axios from "axios";

export default class ProductCategoryService {
    fetchCategories() {
        return axios.get('/v2/products/categories');
    }

    save(name, parentId) {
        return axios.post('/v2/products/categories', {name, parent_id: parentId});
    }

    update(id, name) {
        return axios.put(`/v2/products/categories/${id}`, {name});
    }

    delete(id) {
        return axios.delete(`/v2/products/categories/${id}`);
    }

    deleteAndRewrite(id, data) {
        return axios.delete(`/v2/products/categories/${id}/rewrite`, {
            data: data,
        });
    }

    productCategoryHasRelatedProducts(id) {
        return axios.get(`/v2/products/categories/${id}/has-products`);
    }
}
